// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"656":"70efd409","776":"6cf13059"}[chunkId] + ".chunk.js");